import React from 'react'
import { DatePicker, Space, TimeRangePickerProps } from 'antd'
import ES from 'antd/es/date-picker/locale/es_ES'
import dayjs, { Dayjs } from 'dayjs'

const { RangePicker } = DatePicker

type ReportFiltersProps = {
  dateRange: [Dayjs, Dayjs]
  onDateChange: (dates: [Dayjs, Dayjs]) => void
  loading?: boolean
  children?: React.ReactNode
}

const rangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Hoy', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
  { label: 'Ayer', value: [dayjs().subtract(1, 'd').startOf('day'), dayjs().subtract(1, 'd').endOf('day')] },
  { label: 'Últimos 7 días', value: [dayjs().subtract(7, 'd').startOf('day'), dayjs().endOf('day')] },
  { label: 'Últimos 14 días', value: [dayjs().subtract(14, 'd').startOf('day'), dayjs().endOf('day')] },
  { label: 'Últimos 30 días', value: [dayjs().subtract(30, 'd').startOf('day'), dayjs().endOf('day')] },
  { label: 'Este mes', value: [dayjs().startOf('month'), dayjs().endOf('day')] },
  { label: 'Mes anterior', value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] },
  { label: 'Últimos 90 días', value: [dayjs().subtract(90, 'd').startOf('day'), dayjs().endOf('day')] },
]

function ReportFilters({ dateRange, onDateChange, loading, children }: Readonly<ReportFiltersProps>) {
  const handleChange: TimeRangePickerProps['onChange'] = (dates) => {
    if (dates && dates[0] && dates[1]) {
      onDateChange([dates[0] as Dayjs, dates[1] as Dayjs])
    }
  }

  return (
    <Space size="middle" wrap>
      <RangePicker
        presets={rangePresets}
        format="YYYY/MM/DD"
        value={dateRange}
        locale={ES}
        onChange={handleChange}
        disabled={loading}
        allowClear={false}
        style={{ minWidth: 280 }}
      />
      {children}
    </Space>
  )
}

export default ReportFilters
